import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from 'lucide-react';
import PageHeader from '../Typography/PageHeader/PageHeader';
import BannerImage from '../../assets/banners/policy-documents-banner.jpg';
import BannerImageComponent from '../BannerImage/BannerImage';
import CardGrid from '../Card/CardGrid';
import useFetchAuthMetadata from '../../hooks/useFetchAuthMetadata';
import { getCardData } from '../../data/documentsCardData';

interface PageProps {
  children?: React.ReactNode;
}

const DocumentsPage: React.FC<PageProps> = () => {
  const {
    isAuthenticated,
    loginWithRedirect,
    isLoading: auth0IsLoading,
  } = useAuth0();

  //Get documentCodes from Auth0
  const { metadata } = useFetchAuthMetadata();

  //Edit Documents Card Data based on documentCodes
  const cardData = getCardData(metadata?.management?.codes);

  return (
    <>
      {isAuthenticated ? (
        <div className="container mx-auto px-8 md:px-0 mb-32">
          <BannerImageComponent imgSrc={BannerImage} />
          <PageHeader mainHeaderText="Policy Documents" />
          <CardGrid numberOfCols={2} cardData={cardData} />
        </div>
      ) : (
        <>
          {!auth0IsLoading ? (
            <button
              onClick={() => loginWithRedirect()}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 hover:cursor-pointer"
            >
              Log In
            </button>
          ) : (
            <Loader />
          )}
        </>
      )}
    </>
  );
};

export default DocumentsPage;
